module.exports = __webpack_public_path__ + "static/media/head-bic.6be6d397.png";